import React, { Component } from 'react';
import Modal from 'react-responsive-modal';

export class ModalComponent extends Component {
  render() {
    const {
      open, handleHide, title, children, big = false,
    } = this.props;

    return (
      <Modal
        center
        onClose={handleHide}
        open={open}
        styles={{
          modal: {
            width: '100%',
            height: big ? '100%' : 'auto',
            overflow: 'auto',
          },
          overlay: {
            zIndex: 401,
          },
        }}
      >
        <h2>
          {title}
        </h2>
        {children}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal.js